function formatFieldName(fieldName: string): string {
  return fieldName
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function parseError(e?: any): string {
  let dataString = ''
  try {
    dataString = JSON.stringify(e.data)
  } catch (e) {}

  if (typeof e === 'string') return e
  if (typeof e?.data === 'string') return e.data
  if (typeof e?.data?.detail === 'string') return e.data.detail
  if (typeof e?.data?.message === 'string') return e.data.message

  // Handle validation errors like {"field_name": ["error message"]}
  if (e?.data && typeof e.data === 'object' && !Array.isArray(e.data)) {
    const fieldErrors: string[] = []
    for (const [field, messages] of Object.entries(e.data)) {
      if (Array.isArray(messages) && messages.length > 0) {
        const fieldMessages = (messages as string[])
          .filter((msg) => typeof msg === 'string')
          .join(', ')
        if (fieldMessages) {
          fieldErrors.push(`${formatFieldName(field)}: ${fieldMessages}`)
        }
      }
    }
    if (fieldErrors.length > 0) return fieldErrors.join('; ')
  }

  if (e?.status) return `Error: ${e.status} ${dataString}`

  const message = e?.message?.message || e?.message
  if (typeof message === 'string') return message

  return dataString || 'An unknown error occurred'
}
